import ReactSlider from 'react-slider';
import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { theme } from '@/theme';

export const TrackWrapper = styled(Flex)`
  height: 12px;
  background: ${theme.colors.tertiaryGrey}
  flex-direction: column;
  justify-content: center;
  &.pips-track-0 {
    background: ${theme.colors.primaryDark}
  }
  &.pips-track-1 {
    background: ${theme.colors.tertiaryGrey}
  }
`;

export const Track = styled(Box)`
  content: '';
  display: block;
  height: 12px;
  left: -1px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
`;

export const ThumbLabel = styled(Box)`
  position: absolute;
  font-size: 0.625rem;
  &.thumb-left {
    left: 0;
    bottom: 10px;
  }
  &.thumb-right {
    bottom: 10px;
    right: 0;
  }
`;

export const Thumb = styled(Box)`
  height: 1.8em;
  width: 1.8em;
  top: -0.5em;
  left: -2px;

  background-color: ${theme.colors.white};
  border: 0.32em solid ${theme.colors.primary};
  border-radius: 50%;
  border-radius: 50%;
`;

export const MarkLine = styled.span<{ $isActive: boolean }>`
  background: #999;
  position: absolute;
  height: 0.8em;
  width: 2px;
  margin-left: 1px;
  ${({ $isActive }) =>
    $isActive &&
    css`
      background: ${theme.colors.primaryDark};
    `}
  &.duration-slider-line {
    height: 12px;
    top: -16px;
    right: -4px;
  }
`;

export const StyledReactSlider = styled(ReactSlider<number>)`
  height: 3em;
  margin-bottom: 1.5em;
  .pips-mark {
    top: 1em;
    width: 2em;
    height: 3em;
    line-height: 3em;
    position: absolute;
    font-size: 0.8em;
    color: #999;
    overflow: visible;
    text-align: center;
    top: 16px;
    margin-left: -0.35em;
    cursor: pointer;
    &.deposit-slider-mark {
      &.last {
        text-align: right;
      }
      &.first {
        left: 6px !important;
        text-align: left;
      }
    }
  }
  .pips-track {
    margin: 0 2px;
  }
`;

export const MarkLabel = styled.span<{ $isActive: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  margin-left: 1px;
  width: 2em;
  text-transform: uppercase;
  text-align: center;
  ${({ $isActive }) =>
    $isActive &&
    css`
      font-weight: bold;
      color: ${theme.colors.primaryDark};
    `}
  &.duration-slider-label {
    width: 5em;
    line-height: 1.5em;
    left: -0.8em;
    &.last {
      left: -3em;
      text-align: right;
    }
    &.first {
      left: 0.7em;
      text-align: left;
    }

    ${({ theme }) => theme.media.sm.up} {
      width: 5.9em;
      line-height: 3em;

      &.last {
        left: -3.5em;
      }
    }
  }
`;
